import {
  ATTACK_ROLL,
  VERY_CLOSE,
} from '../../character/content/templates';

export default function Weapons() {
    return (
        <>
            <p>All weapons have a tier, trait, range, damage die, damage
                type, and burden. Some weapons also have a feature.
            </p>
            <h3>CATEGORY</h3>
            <p>A weapon's <strong>category</strong> specifies whether it is a Primary or
                Secondary weapon. Your character can only equip up to one
                weapon of each category at a time.</p>
            <h3>TRAIT</h3>
            <p>A weapon's <strong>trait</strong> specifies which trait to use when making an
                {ATTACK_ROLL} with it.</p>
            <h3>RANGE</h3>
            <p>A weapon's <strong>range</strong> specifies the maximum distance between
                the attacker and their target when attacking with it.</p>
            <h3>DAMAGE</h3>
            <p>A weapon's <strong>damage</strong> indicates the size of the damage dice
                you roll on a successful {ATTACK_ROLL} with it; you roll a number of
                dice equal to your Proficiency. If the damage includes a flat
                modifier, this number is added to the total damage rolled, but
                is not altered or affected by Proficiency.</p>
            <h3>DAMAGE TYPE</h3>
            <p>A weapon's <strong>damage type</strong> indicates whether it deals physical
                or magic damage. Weapons that deal magic damage can only
                be wielded by characters with a Spellcast trait.
            </p>
            <h3>BURDEN</h3>
            <p>A weapon's <strong>burden</strong> indicates how many <strong>hands</strong> it occupies
                when equipped. Your character's maximum burden is 2 hands.</p>
            <h3>FEATURE</h3>
            <p>A weapon's <strong>feature</strong> is a special rule that stays in effect while
                the weapon is equipped.
                You can throw an equipped weapon at a target within {VERY_CLOSE}
                range, making the {ATTACK_ROLL} with Finesse. On a
                success, deal damage as usual for that weapon. Once thrown,
                the weapon is no longer considered equipped. Until you
                retrieve and re-equip it, you can't {ATTACK_ROLL} with it or benefit from
                its features.</p>
        </>
    );
}